import PanelTemplate from "components/shared/profile/panel";
import React from "react";
import { editOrganizationContacts, getOrganizationContacts } from "sources/profile/organization";
import { config, initialState } from "./config";

class DriverMainContacts extends PanelTemplate {
    state = {
        data: { contacts: [] },
        isValid: true,
    };

    componentDidMount() {
        getOrganizationContacts().then((data) => this.setState({ data: { contacts: data }, initial: { ...data } }));
    }

    componentDidUpdate() {
        return undefined;
    }

    renderBody = () => {
        return (
            <>
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Наименование контакта</th>
                            <th>ФИО</th>
                            <th>Номер телефона</th>
                            <th>Скрыть в приложении</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>{this.state.data.contacts.map(this.renderItem)}</tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={6}>
                                <div className="inline-btn inline-btn--plus mt-2" onClick={this.addItem}>
                                    Добавить
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </>
        );
    };

    addItem = () => {
        this.setState({
            data: {
                contacts: [
                    ...this.state.data.contacts,
                    {
                        name: "",
                        fullName: "",
                        phoneNumber: "",
                        isHidden: false,
                    },
                ],
            },
        });
    };

    removeItem = (index) => {
        const contacts = [...this.state.data.contacts];
        contacts.splice(index, 1);
        this.setState({ data: { contacts } });
    };

    renderItem = (item, i) => {
        const { editable } = this.props;
        const { config } = this.props.config.contacts;
        const onChange = ({ name, value }) => {
            const newVal = this.state.data.contacts.map((contact, index) => ({
                ...contact,
                ...(index === i ? { [name]: value } : {}),
            }));
            this.setState({ data: { contacts: newVal } });
        };
        return (
            <tr key={i}>
                <td className="align-middle">{i + 1}</td>
                <td className="align-middle">
                    {this.renderField({ ...config.name, disabled: !editable, value: item.name, onChange })}
                </td>
                <td className="align-middle">
                    {this.renderField({ ...config.fullName, disabled: !editable, value: item.fullName, onChange })}
                </td>
                <td className="align-middle">
                    {this.renderField({
                        ...config.phoneNumber,
                        disabled: !editable,
                        value: item.phoneNumber,
                        onChange,
                    })}
                </td>
                <td className="align-middle">
                    {this.renderCheckbox({ ...config.isHidden, disabled: !editable, value: item.isHidden, onChange })}
                </td>
                <td className="align-middle">
                    <div className="btn btn-xs btn-outline-danger font-weight-bold" onClick={() => this.removeItem(i)}>
                        ×
                    </div>
                </td>
            </tr>
        );
    };

    update = () => {
        const { data } = this.state;
        if (!this.isValidForm(data)) {
            this.props.setIsValid(false);
            return this.setState({ isValid: false });
        }
        return editOrganizationContacts(data).then((res) => {
            if (!res) {
                this.setState({ isValid: false });
            }
            this.setState({ shouldUpdate: false });
        });
    };

    renderButton = () => {
        return (
            this.props.editable && (
                <div className="panel__row panel__row--button">
                    <div className="btn btn-brand btn-sm" onClick={this.update}>
                        Обновить
                    </div>
                </div>
            )
        );
    };

    render() {
        return (
            <>
                {this.renderBody()}
                {this.renderButton()}
            </>
        );
    }
}

const ConfiguredPanel = (props) => <DriverMainContacts {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
